document.addEventListener("DOMContentLoaded", () => {
  console.log("[quote] quote.js loaded");
  console.log(
    "[quote] modal-dialog defined:",
    !!customElements.get("modal-dialog"),
  );

  const WEBHOOK_URL =
    "https://n8n.srv1336295.hstgr.cloud/webhook/demande-de-devis";
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll("modal-dialog.quote-modal").forEach((modal) => {
    const send = modal.querySelector(".quote-send");
    const nameInput = modal.querySelector(".quote-name");
    const emailInput = modal.querySelector(".quote-email");
    const phoneInput = modal.querySelector(".quote-phone");
    const messageInput = modal.querySelector(".quote-message");
    const formWrapper = modal.querySelector(".quote-form-wrapper");
    const success = modal.querySelector(".quote-success");
    const errorBox = modal.querySelector(".quote-error");
    const closeBtn = modal.querySelector(".quote-close-btn");

    console.log(
      "[quote] modal found -> send:",
      !!send,
      "| name:",
      !!nameInput,
      "| email:",
      !!emailInput,
      "| message:",
      !!messageInput,
    );

    if (!send) return;

    send.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      console.log("[quote] send clicked");

      if (!nameInput || !emailInput || !messageInput) {
        console.log("[quote] fields missing in DOM");
        return;
      }

      [nameInput, emailInput, messageInput].forEach((field) =>
        field.classList.remove("field--error"),
      );
      errorBox?.classList.add("hidden");

      const invalidFields = [];
      if (!nameInput.value.trim()) invalidFields.push(nameInput);
      if (
        !emailInput.value.trim() ||
        !EMAIL_REGEX.test(emailInput.value.trim())
      )
        invalidFields.push(emailInput);

      if (invalidFields.length > 0) {
        invalidFields.forEach((field) => field.classList.add("field--error"));
        if (errorBox) {
          errorBox.textContent =
            errorBox.dataset.validateError ||
            "Please fill in all required fields.";
          errorBox.classList.remove("hidden");
        }
        console.log(
          "[quote] validation failed:",
          invalidFields.length,
          "invalid field(s)",
        );
        return;
      }

      send.disabled = true;
      const originalHTML = send.innerHTML;
      send.innerHTML = '<span class="quote-spinner" aria-hidden="true"></span>';

      const payload = {
        name: nameInput.value.trim(),
        email: emailInput.value.trim(),
        phone: phoneInput ? phoneInput.value.trim() : "",
        message: messageInput.value.trim(),
        product_id: modal.dataset.product,
        product_title: modal.dataset.productTitle,
        variant_id: modal.dataset.variant,
        variant_value: modal.dataset.variantvalue,
        shopify_url: window.location.href,
      };

      console.log("[quote] payload:", JSON.stringify(payload));

      let delivered = false;

      try {
        const response = await fetch(WEBHOOK_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        delivered = response.ok;
        console.log("[quote] fetch status:", response.status, "ok:", delivered);
      } catch (error) {
        console.log("[quote] fetch error:", error);
        delivered = false;
      }

      if (!delivered && navigator.sendBeacon) {
        try {
          const blob = new Blob([JSON.stringify(payload)], {
            type: "application/json",
          });
          delivered = navigator.sendBeacon(WEBHOOK_URL, blob);
          console.log("[quote] sendBeacon queued:", delivered);
        } catch (error) {
          console.log("[quote] sendBeacon error:", error);
          delivered = false;
        }
      }

      if (!delivered) {
        send.disabled = false;
        send.innerHTML = originalHTML;
        if (errorBox) {
          errorBox.textContent =
            errorBox.dataset.error || "Something went wrong, please try again.";
          errorBox.classList.remove("hidden");
        }
        console.log("[quote] NOT delivered to webhook");
        return;
      }

      formWrapper?.classList.add("hidden");
      success?.classList.remove("hidden");
      console.log("[quote] delivered -> success state");
    });

    closeBtn?.addEventListener("click", () => {
      formWrapper?.classList.remove("hidden");
      success?.classList.add("hidden");
      send.disabled = false;
      if (typeof modal.hide === "function") modal.hide();
    });
  });
});
